const PublicUrls = [
    { path: "/", text: "Home" },
    { path: "/browse-parking-lot", text: "Browse Parking Lots" },
    { path: "/about", text: "About" },
    { path: "/contact", text: "Contact" },
    { path: "/faq", text: "FAQ" },
    { path: "/pricing", text: "Pricing" }
]
const LotOperatorUrls = [
    { path: "/business-dashboard", text: "Parking Lot Dashboard" },
    { path: "/archive-home", text: "Archive" },
    { path: "/my-tickets", text: "Support" },
    { path: "/billing", text: "Billing" }
];

const AdvertiserUrls = [
    { path: "/dashboard", text: "Advertisements Dashboard" },
    { path: "/create-ad", text: "Create Ad" },
    { path: "/my-tickets", text: "Support" },
    { path: "/billing", text: "Billing" }
];

const CustomerSupportUrls = [
    { path: "/dashboard", text: "Support Dashboard" },
    { path: "/lot-admin", text: "Lot Admin" },
    { path: "/ad-admin", text: "Ad Admin" },
    { path: "/admin-create-ad", text: "Create Ad" },
    { path: "/manage-accounts", text: "Manage User Accounts" }
];

const LotSpecialistUrls = [
    { path: "/dashboard", text: "Lot Support Dashboard" },
    { path: "/lot-admin", text: "Lot Admin" },
    { path: "/manage-accounts", text: "Manage Lot Accounts" }
];

const AdvertisingSpecialistUrls = [
    { path: "/dashboard", text: "Ad Support Dashboard" },
    { path: "/ad-admin", text: "Ad Admin" },
    { path: "/admin-create-ad", text: "Create Ad" },
    { path: "/manage-accounts", text: "Manage Ad Accounts" }
];

const AccountantUrls = [
    { path: "/dashboard", text: "Accountant Dashboard" },
    { path: "/add-invoice", text: "New Invoice" },
    { path: "/choose-lot-dashboard", text: "Lot Admin" },
    { path: "/manage-accounts", text: "Manage Accounts" },
    { path: "/create-staff-account", text: "Create Employees" },
];

export { 
    LotOperatorUrls, 
    AdvertiserUrls, 
    CustomerSupportUrls, 
    LotSpecialistUrls, 
    AdvertisingSpecialistUrls, 
    AccountantUrls,
    PublicUrls
};

